	export enum SalesOrderClaimProcessingStatusEnum {
		NotPerformed = 1,
		Success = 2,
		Error = 3,
		SuccessWithErrors = 4
	}
